<template>
  <kendo-tooltip
    :title="situacaoText"
    :position="'top'"
    ref="tooltip"
    :animation="animation"
  >
    <div
      :id="templateArgs.id"
      data-toggle="tooltip"
      class="situacao-circle"
      :style="{ backgroundColor: backgroundColorOptions[`${situacaoText}`] }"
      ref="situacaoCirculo"
    ></div>
  </kendo-tooltip>
</template>

<script>
export default {
  data() {
    return {
      templateArgs: {},
      backgroundColorOptions: {},
      situacaoText: "",
      animation: {
        open: {
          effects: "zoom",
          duration: 150,
        },
      },
    };
  },
  watch: {
    templateArgs: {
      handler(newVal, oldVal) {
        const situacaoNumber = newVal.situacao;
        this.situacaoText = newVal.data.situacoesOpcoes[situacaoNumber];
      },
    },
  },
  methods: {
    setBackgroundcolorOptions(customColors) {
      this.backgroundColorOptions = {
        Pendente: "#ffd700",
        Aprovado: "#42ba96",
        Reprovado: "#df4759",
        Cancelado: "#8897aa",

        Agendado: "#ffd700",
        Executado: "#42ba96",
        Reprocessar: "#ffad33",
      };
      if (customColors) {
        customColors.forEach((e) => {
          this.backgroundColorOptions[e.statusText] = e.cor;
        });
        return;
      }
    },
  },
  mounted() {
    this.setBackgroundcolorOptions();
    const customColorsEntry =  this.templateArgs.data.customColors
    if(customColorsEntry){
      this.setBackgroundcolorOptions(customColorsEntry);
    }
  },
};
</script>

<style scoped>
::v-deep .situacao-circle {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin: auto;
  transition: all 300ms;
  cursor: pointer;
}

::v-deep .situacao-circle:hover {
  filter: brightness(1.25);
}
</style>